import GetBox from '@/Pages/FrontPage/components/GetBox';
import './GetLessons.scss';
export const GetLessons =()=>{
  return (
    <section className="getLessons">
      <GetBox />
    </section>
  );
}